import { render, staticRenderFns } from "./frozenWave.vue?vue&type=template&id=703ca65a&"
import script from "./frozenWave.vue?vue&type=script&lang=js&"
export * from "./frozenWave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports